import ArticleTag from './ArticleTag';

export default ArticleTag;
